module.exports = __webpack_public_path__ + "img/1536856554.04d88539.jpg";